module.exports = __webpack_public_path__ + "img/sort-asc.32ad283d.svg";